export class AccountApiError extends Error {
  constructor(message, status, details) {
    super(message)
    this.name = 'AccountApiError'
    this.status = status
    this.details = details
  }
}

async function request(path, options = {}, { optional = false } = {}) {
  let response
  try {
    response = await fetch(path, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...options.headers,
      },
      ...options,
    })
  } catch (error) {
    if (optional) return null
    throw new AccountApiError('Connexion impossible pour le moment.', 0, error)
  }

  const data = await response.json().catch(() => null)
  if (optional && (response.status === 404 || response.status === 501)) return null
  if (!response.ok) {
    throw new AccountApiError(
      data?.error || data?.message || 'Cette action est indisponible pour le moment.',
      response.status,
      data,
    )
  }
  return data
}

const post = (path, body) => request(path, {
  method: 'POST',
  body: JSON.stringify(body || {}),
})

export const accountApi = {
  account: () => request('/api/account', {}, { optional: true }),
  stats: () => request('/api/me/stats', {}, { optional: true }),
  history: (limit = 90) => request(
    `/api/me/history?limit=${encodeURIComponent(limit)}`,
    {},
    { optional: true },
  ),
  startEmail: (email) => post('/api/auth/email/start', { email }),
  confirmEmail: ({ email, code, challengeId }) => post('/api/auth/email/confirm', {
    email,
    code,
    ...(challengeId ? { challengeId } : {}),
  }),
  exportAccount: () => request('/api/account/export'),
  deleteAccount: () => request('/api/account', {
    method: 'DELETE',
    body: JSON.stringify({ confirm: true }),
  }),
  logout: () => post('/api/auth/logout'),
  passkeyRegistrationOptions: () => post('/api/auth/passkeys/register/options'),
  verifyPasskeyRegistration: (response, challengeId) => post('/api/auth/passkeys/register/verify', { response, challengeId }),
  passkeyLoginOptions: () => post('/api/auth/passkeys/login/options'),
  verifyPasskeyLogin: (response, challengeId) => post('/api/auth/passkeys/login/verify', { response, challengeId }),
}
